module.exports = __webpack_public_path__ + "static/media/casa3.837176ff.png";